import angular from "angular";

import uiRouterModule from "@uirouter/angularjs";
import TrackerBaseReportsConstants from "./Constants";
import ReportConfiguration from "./ReportConfiguration";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackingSummaryReportController from "./TrackingSummaryReportController";

const reportConfiguration = new ReportConfiguration({
    reportDisplayName: "Daily Tracking Summary",
    reportStateName: "dailyTrackingSummary"
});

function TrackingSummaryReportConfiguration($stateProvider) {
    $stateProvider.state(
        `${TrackerBaseReportsConstants.rootStateName}.${reportConfiguration.stateName}`,
        {
            url: "/daily-tracking-summary",
            template: TrackingSummaryReportController.template,
            controller: TrackingSummaryReportController,
            controllerAs: TrackingSummaryReportController.controllerAs,
            data: {
                featureToggles: {
                    sendReportFeature: true
                }
            }
        }
    );
}

TrackingSummaryReportConfiguration.$inject = [ "$stateProvider" ];

TrackingSummaryReportConfiguration.dependencies = [ uiRouterModule ];

const trackingSummaryReportModuleDependencies = DependencyListBuilder([
    TrackingSummaryReportController.dependencies,
    TrackingSummaryReportConfiguration.dependencies
]);

export default {
    moduleName: angular
                    .module(
                        "trackerbase-app.views.trackerbase-reports.daily-tracking-summary-report",
                        trackingSummaryReportModuleDependencies
                    )
                    .config(TrackingSummaryReportConfiguration)
                    .name,
    configs: [ reportConfiguration ]
};




//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/TrackingSummaryReport.js
// module id = sUZ2
// module chunks = 1